import React from 'react';
import PropTypes from 'prop-types';
import './index.scss';

const Button = ({ children, onClick, type = 'button', disabled = false }) => {
  return (
    <button type={type} className="primary-button" onClick={onClick} disabled={disabled}>
      {children}
    </button>
  );
};

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  disabled: PropTypes.bool
};

export default Button;
